"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavigation = exports.NavigationProvider = exports.UpLinkWithHistory = exports.LinkWithHistory = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../theme");
const NavigationContext = (0, react_1.createContext)(undefined);
const LinkWithHistory = ({ to, children, className, style, paramUpdates, }) => {
    const { addToHistory } = (0, exports.useNavigation)();
    const [searchParams] = (0, react_router_dom_1.useSearchParams)();
    const finalUrl = (0, react_1.useMemo)(() => {
        const next = new URLSearchParams(searchParams);
        if (paramUpdates) {
            Object.entries(paramUpdates).forEach(([k, v]) => next.set(k, v));
        }
        const queryString = next.toString();
        return queryString ? `${to}?${queryString}` : to;
    }, [to, searchParams, paramUpdates]);
    return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: finalUrl, onClick: () => addToHistory(finalUrl), className: className, style: style, children: children }));
};
exports.LinkWithHistory = LinkWithHistory;
const BackLink = (0, styled_components_1.default)(react_router_dom_1.Link) `
  margin-bottom: ${theme_1.theme.spacing(2)};
  ${theme_1.theme.fontBold};
  ${theme_1.theme.fontSize(-1)};
  color: ${theme_1.theme.colors.bluelink};
  text-decoration-style: none;
  text-decoration-line: none;
`;
const UpLinkWithHistory = ({ to, children, className, style, }) => {
    const { goUp } = (0, exports.useNavigation)();
    return ((0, jsx_runtime_1.jsxs)(BackLink, { to: to, onClick: () => goUp(), className: className, style: style, children: ["\u2039 ", children] }));
};
exports.UpLinkWithHistory = UpLinkWithHistory;
const NavigationProvider = ({ children }) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    const [history, setHistory] = (0, react_1.useState)([location.pathname]);
    const currentPath = history[history.length - 1];
    const upPath = history.length > 1 ? history[history.length - 2] : null;
    const [searchParams] = (0, react_router_dom_1.useSearchParams)();
    const navigateAndSetHistory = (0, react_1.useCallback)((path) => {
        const next = new URLSearchParams(searchParams);
        const queryString = next.toString();
        const finalUrl = queryString ? `${path}?${queryString}` : path;
        setHistory((prev) => [...prev, finalUrl]);
        navigate(finalUrl);
    }, []);
    const addToHistory = (0, react_1.useCallback)((path) => {
        setHistory((prev) => [...prev, path]);
    }, []);
    const goUp = (0, react_1.useCallback)(() => {
        setHistory((prev) => (prev.length > 1 ? prev.slice(0, -1) : prev));
    }, []);
    return ((0, jsx_runtime_1.jsx)(NavigationContext.Provider, { value: {
            history,
            currentPath,
            upPath,
            addToHistory,
            navigate: navigateAndSetHistory,
            goUp,
        }, children: children }));
};
exports.NavigationProvider = NavigationProvider;
const useNavigation = () => {
    const context = (0, react_1.useContext)(NavigationContext);
    if (!context) {
        throw new Error("useNavigation must be used within a NavigationProvider");
    }
    return context;
};
exports.useNavigation = useNavigation;
